import { Button } from "@tennr/frontend/components/Button/Button";
import { Link } from "@tanstack/react-router";
import { useMobile } from "@tennr/frontend/hooks/useMobile";

import "./DeepDiveCopy.css";
import { Heading } from "@tennr/frontend/components/Heading";

export const DeepDiveCopy = (props) => {
  const isMobile = useMobile();

  return (
    <div className="deep-dive-copy">
      <Heading
        heading={
          isMobile
            ? "Tennr sets a new \nstandard for \nhealthcare ops"
            : "Tennr sets a new standard \nfor healthcare ops"
        }
        title="OPERATIONAL EXCELLENCE AT SCALE"
        body="Leading providers move faster, improve quality, and drive revenue with less effort. "
        color="dark"
        variant="section"
        width={560}
        multiLineTitle={true}
        {...(props?.heading ?? {})}
      />
      {props?.button && 
        <Link to="/book-a-demo">
          <Button
            minWidth="169px"
            className={"left-offset-button"}
            minHeight="58px"
            text="GET STARTED"
          />
        </Link>
      }
    </div>
  );
};
